export default class CreatePersonalConvocatoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPersonal, payload) {
    try {
      const result = await this.#repository.createPersonalConvocatoria(idPersonal, payload)
      return result
    } catch (error) {
      console.error('Error al crear la asignación de personal a convocatoria:', error)
      throw error
    }
  }
}
